import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import { formatDate } from '../utils/formatDate';
import './DataPage.css';

const styles = {
  page: {
    backgroundColor: '#f5f5f5',
    minHeight: '100vh',
  },
  breadcrumb: {
    fontSize: '13px',
    color: '#999',
    marginBottom: '4px',
  },
  breadcrumbLink: {
    color: '#1976d2',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  pageHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  pageIcon: {
    fontSize: '1.5rem',
    lineHeight: 1,
  },
  pageTitle: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 2px 0',
  },
  pageSubtitle: {
    fontSize: '0.85rem',
    color: '#666',
    margin: 0,
  },
  tabsContainer: {
    display: 'flex',
    gap: '0',
    marginBottom: '24px',
    borderBottom: '2px solid #e0e0e0',
  },
  tabActive: {
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#1976d2',
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '3px solid #1976d2',
    cursor: 'pointer',
    marginBottom: '-2px',
    transition: 'color 0.2s',
  },
  tabInactive: {
    padding: '12px 24px',
    fontSize: '14px',
    fontWeight: '500',
    color: '#666',
    backgroundColor: 'transparent',
    border: 'none',
    borderBottom: '3px solid transparent',
    cursor: 'pointer',
    marginBottom: '-2px',
    transition: 'color 0.2s',
  },
  filtersCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    padding: '20px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    marginBottom: '24px',
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-end',
    flexWrap: 'wrap',
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: '180px',
  },
  filterGroupFlex: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: '200px',
  },
  filterLabel: {
    fontSize: '12px',
    color: '#666',
    marginBottom: '6px',
    fontWeight: '500',
  },
  input: {
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    color: '#333',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  select: {
    padding: '10px 12px',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    color: '#333',
    outline: 'none',
    backgroundColor: '#fff',
    cursor: 'pointer',
    width: '100%',
    boxSizing: 'border-box',
  },
  searchBtn: {
    padding: '10px 24px',
    backgroundColor: '#1976d2',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  clearBtn: {
    padding: '10px 20px',
    backgroundColor: '#f5f5f5',
    color: '#666',
    border: '1px solid #ddd',
    borderRadius: '6px',
    fontSize: '14px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    transition: 'background-color 0.2s',
  },
  tableCard: {
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    overflow: 'hidden',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '14px',
  },
  th: {
    padding: '14px 16px',
    textAlign: 'left',
    backgroundColor: '#fafafa',
    color: '#555',
    fontWeight: '600',
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '2px solid #eee',
    whiteSpace: 'nowrap',
  },
  thRight: {
    padding: '14px 16px',
    textAlign: 'right',
    backgroundColor: '#fafafa',
    color: '#555',
    fontWeight: '600',
    fontSize: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
    borderBottom: '2px solid #eee',
    whiteSpace: 'nowrap',
  },
  td: {
    padding: '12px 16px',
    borderBottom: '1px solid #f0f0f0',
    color: '#333',
  },
  tdRight: {
    padding: '12px 16px',
    borderBottom: '1px solid #f0f0f0',
    color: '#333',
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  },
  rowEven: {
    backgroundColor: '#fff',
  },
  rowOdd: {
    backgroundColor: '#fafafa',
  },
  totalRow: {
    backgroundColor: '#f0f0f0',
    fontWeight: 'bold',
  },
  totalTd: {
    padding: '14px 16px',
    borderBottom: 'none',
    color: '#333',
    fontWeight: '700',
    fontSize: '14px',
  },
  totalTdRight: {
    padding: '14px 16px',
    borderBottom: 'none',
    color: '#333',
    fontWeight: '700',
    fontSize: '14px',
    textAlign: 'right',
    fontVariantNumeric: 'tabular-nums',
  },
  loading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '60px',
    color: '#666',
    fontSize: '16px',
  },
  emptyState: {
    textAlign: 'center',
    padding: '60px 20px',
    color: '#999',
  },
  emptyTitle: {
    fontSize: '18px',
    fontWeight: '500',
    color: '#666',
    margin: '0 0 8px 0',
  },
  emptyText: {
    fontSize: '14px',
    color: '#999',
    margin: 0,
  },
  convenioBadge: {
    display: 'inline-block',
    padding: '4px 10px',
    borderRadius: '12px',
    fontSize: '12px',
    fontWeight: '500',
    backgroundColor: '#e8f5e9',
    color: '#2e7d32',
  },
};

function getDefaultDataInicio() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
}

function getDefaultDataFim() {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
}

// formatDate importado de ../utils/formatDate

function formatCurrency(value) {
  if (value === null || value === undefined || value === '') return 'R$ 0,00';
  const num = typeof value === 'number' ? value : parseFloat(value);
  if (isNaN(num)) return 'R$ 0,00';
  return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

function Faturamento() {
  const [activeTab, setActiveTab] = useState('faturas');

  // Estado Faturas
  const [faturas, setFaturas] = useState([]);
  const [loadingFaturas, setLoadingFaturas] = useState(false);
  const [dataInicioFaturas, setDataInicioFaturas] = useState(getDefaultDataInicio());
  const [dataFimFaturas, setDataFimFaturas] = useState(getDefaultDataFim());
  const [searchFaturas, setSearchFaturas] = useState('');
  const [convenioFilter, setConvenioFilter] = useState('');
  const [conveniosUnicos, setConveniosUnicos] = useState([]);

  // Estado Resumo
  const [resumo, setResumo] = useState([]);
  const [loadingResumo, setLoadingResumo] = useState(false);
  const [dataInicioResumo, setDataInicioResumo] = useState(getDefaultDataInicio());
  const [dataFimResumo, setDataFimResumo] = useState(getDefaultDataFim());

  useEffect(() => {
    if (activeTab === 'faturas') {
      fetchFaturas();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === 'resumo') {
      fetchResumo();
    }
  }, [activeTab]);

  const fetchFaturas = async () => {
    setLoadingFaturas(true);
    try {
      const params = new URLSearchParams();
      if (dataInicioFaturas) params.append('dataInicio', dataInicioFaturas);
      if (dataFimFaturas) params.append('dataFim', dataFimFaturas);
      if (searchFaturas) params.append('search', searchFaturas);
      if (convenioFilter) params.append('convenio', convenioFilter);

      const response = await axios.get(`${API_URL}/financeiro/faturas?${params.toString()}`);
      const data = Array.isArray(response.data) ? response.data : (response.data.data || []);
      setFaturas(data);

      // Extrair convenios unicos para o filtro
      if (!convenioFilter) {
        const convenios = [...new Set(data.map(f => f.CONVENIO).filter(Boolean))].sort();
        setConveniosUnicos(convenios);
      }
    } catch (err) {
      console.error('Erro ao buscar faturas:', err);
      setFaturas([]);
    } finally {
      setLoadingFaturas(false);
    }
  };

  const fetchResumo = async () => {
    setLoadingResumo(true);
    try {
      const params = new URLSearchParams();
      if (dataInicioResumo) params.append('dataInicio', dataInicioResumo);
      if (dataFimResumo) params.append('dataFim', dataFimResumo);

      const response = await axios.get(`${API_URL}/financeiro/faturas/resumo?${params.toString()}`);
      const data = Array.isArray(response.data) ? response.data : (response.data.data || []);
      setResumo(data);
    } catch (err) {
      console.error('Erro ao buscar resumo:', err);
      setResumo([]);
    } finally {
      setLoadingResumo(false);
    }
  };

  const totalGeralFaturas = faturas.reduce((acc, f) => {
    const val = typeof f.VALOR === 'number' ? f.VALOR : parseFloat(f.VALOR) || 0;
    return acc + val;
  }, 0);

  const totalGeralResumoItens = resumo.reduce((acc, r) => {
    return acc + (parseInt(r.TOTAL_ITENS) || 0);
  }, 0);

  const totalGeralResumoValor = resumo.reduce((acc, r) => {
    const val = typeof r.VALOR_TOTAL === 'number' ? r.VALOR_TOTAL : parseFloat(r.VALOR_TOTAL) || 0;
    return acc + val;
  }, 0);

  const renderFaturas = () => (
    <>
      {/* Filtros Faturas */}
      <div className="responsive-flex page-filters" style={styles.filtersCard}>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Data Inicio</label>
          <input
            type="date"
            value={dataInicioFaturas}
            onChange={(e) => setDataInicioFaturas(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Data Fim</label>
          <input
            type="date"
            value={dataFimFaturas}
            onChange={(e) => setDataFimFaturas(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.filterGroupFlex}>
          <label style={styles.filterLabel}>Buscar (paciente/protocolo)</label>
          <input
            type="text"
            placeholder="Digite para buscar..."
            value={searchFaturas}
            onChange={(e) => setSearchFaturas(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Convenio</label>
          <select
            value={convenioFilter}
            onChange={(e) => setConvenioFilter(e.target.value)}
            style={styles.select}
          >
            <option value="">Todos</option>
            {conveniosUnicos.map(conv => (
              <option key={conv} value={conv}>{conv}</option>
            ))}
          </select>
        </div>
        <button
          style={styles.searchBtn}
          onClick={fetchFaturas}
          onMouseEnter={(e) => { e.target.style.backgroundColor = '#1565c0'; }}
          onMouseLeave={(e) => { e.target.style.backgroundColor = '#1976d2'; }}
        >
          Buscar
        </button>
        {(searchFaturas || convenioFilter || dataInicioFaturas !== getDefaultDataInicio() || dataFimFaturas !== getDefaultDataFim()) && (
          <button
            style={styles.clearBtn}
            onClick={() => {
              setSearchFaturas('');
              setConvenioFilter('');
              setDataInicioFaturas(getDefaultDataInicio());
              setDataFimFaturas(getDefaultDataFim());
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#eee'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#f5f5f5'; }}
          >
            Limpar
          </button>
        )}
      </div>

      {/* Tabela Faturas */}
      <div style={styles.tableCard}>
        {loadingFaturas ? (
          <div style={styles.loading}>Carregando faturas...</div>
        ) : faturas.length === 0 ? (
          <div style={styles.emptyState}>
            <p style={styles.emptyTitle}>Nenhuma fatura encontrada</p>
            <p style={styles.emptyText}>Tente ajustar os filtros de busca ou o periodo.</p>
          </div>
        ) : (
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={styles.th}>Protocolo</th>
                  <th style={styles.th}>Data</th>
                  <th style={{ ...styles.th, minWidth: '200px' }}>Paciente</th>
                  <th style={styles.th}>Convenio</th>
                  <th style={styles.th}>Plano</th>
                  <th style={{ ...styles.th, minWidth: '180px' }}>Exame</th>
                  <th style={styles.thRight}>Valor</th>
                </tr>
              </thead>
              <tbody>
                {faturas.map((fatura, index) => (
                  <tr
                    key={`${fatura.ID}-${index}`}
                    style={{
                      ...(index % 2 === 0 ? styles.rowEven : styles.rowOdd),
                      transition: 'background-color 0.15s',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e8f0fe'; }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fff' : '#fafafa';
                    }}
                  >
                    <td style={styles.td}><strong>{fatura.PROTOCOLO || fatura.ID}</strong></td>
                    <td style={styles.td}>{formatDate(fatura.DATA)}</td>
                    <td style={styles.td}>{fatura.PACIENTE || '-'}</td>
                    <td style={styles.td}>
                      {fatura.CONVENIO ? (
                        <span style={styles.convenioBadge}>{fatura.CONVENIO}</span>
                      ) : '-'}
                    </td>
                    <td style={styles.td}>{fatura.PLANO || '-'}</td>
                    <td style={styles.td}>{fatura.DESCRICAO || fatura.EXAME || '-'}</td>
                    <td style={styles.tdRight}>{formatCurrency(fatura.VALOR)}</td>
                  </tr>
                ))}
                {/* Total geral */}
                <tr style={styles.totalRow}>
                  <td style={styles.totalTd} colSpan={6}>
                    Total Geral ({faturas.length} {faturas.length === 1 ? 'registro' : 'registros'})
                  </td>
                  <td style={styles.totalTdRight}>{formatCurrency(totalGeralFaturas)}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );

  const renderResumo = () => (
    <>
      {/* Filtros Resumo */}
      <div className="responsive-flex page-filters" style={styles.filtersCard}>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Data Inicio</label>
          <input
            type="date"
            value={dataInicioResumo}
            onChange={(e) => setDataInicioResumo(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>Data Fim</label>
          <input
            type="date"
            value={dataFimResumo}
            onChange={(e) => setDataFimResumo(e.target.value)}
            style={styles.input}
          />
        </div>
        <button
          style={styles.searchBtn}
          onClick={fetchResumo}
          onMouseEnter={(e) => { e.target.style.backgroundColor = '#1565c0'; }}
          onMouseLeave={(e) => { e.target.style.backgroundColor = '#1976d2'; }}
        >
          Buscar
        </button>
        {(dataInicioResumo !== getDefaultDataInicio() || dataFimResumo !== getDefaultDataFim()) && (
          <button
            style={styles.clearBtn}
            onClick={() => {
              setDataInicioResumo(getDefaultDataInicio());
              setDataFimResumo(getDefaultDataFim());
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#eee'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#f5f5f5'; }}
          >
            Limpar
          </button>
        )}
      </div>

      {/* Tabela Resumo */}
      <div style={styles.tableCard}>
        {loadingResumo ? (
          <div style={styles.loading}>Carregando resumo...</div>
        ) : resumo.length === 0 ? (
          <div style={styles.emptyState}>
            <p style={styles.emptyTitle}>Nenhum dado encontrado</p>
            <p style={styles.emptyText}>Tente ajustar o periodo de busca.</p>
          </div>
        ) : (
          <div style={styles.tableWrapper}>
            <table style={styles.table}>
              <thead>
                <tr>
                  <th style={{ ...styles.th, minWidth: '200px' }}>Convenio</th>
                  <th style={styles.thRight}>Total Itens</th>
                  <th style={styles.thRight}>Valor Total</th>
                  <th style={styles.th}>Periodo</th>
                </tr>
              </thead>
              <tbody>
                {resumo.map((item, index) => (
                  <tr
                    key={`${item.CONVENIO}-${index}`}
                    style={{
                      ...(index % 2 === 0 ? styles.rowEven : styles.rowOdd),
                      transition: 'background-color 0.15s',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e8f0fe'; }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#fff' : '#fafafa';
                    }}
                  >
                    <td style={styles.td}>
                      <span style={styles.convenioBadge}>{item.CONVENIO || '-'}</span>
                    </td>
                    <td style={styles.tdRight}>{parseInt(item.TOTAL_ITENS || 0).toLocaleString('pt-BR')}</td>
                    <td style={styles.tdRight}>{formatCurrency(item.VALOR_TOTAL)}</td>
                    <td style={styles.td}>
                      {formatDate(item.DATA_INICIO)} - {formatDate(item.DATA_FIM)}
                    </td>
                  </tr>
                ))}
                {/* Total geral */}
                <tr style={styles.totalRow}>
                  <td style={styles.totalTd}>
                    Total ({resumo.length} {resumo.length === 1 ? 'convenio' : 'convenios'})
                  </td>
                  <td style={styles.totalTdRight}>{totalGeralResumoItens.toLocaleString('pt-BR')}</td>
                  <td style={styles.totalTdRight}>{formatCurrency(totalGeralResumoValor)}</td>
                  <td style={styles.totalTd}></td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );

  return (
    <div className="data-page" style={styles.page}>
      {/* Breadcrumb */}
      <div style={styles.breadcrumb}>
        <span style={styles.breadcrumbLink}>Inicio</span>
        <span> / </span>
        <span>Faturamento</span>
      </div>

      {/* Header */}
      <div style={styles.pageHeader}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={styles.pageIcon}>💳</span>
          <div>
            <h1 style={styles.pageTitle}>Faturamento</h1>
            <p style={styles.pageSubtitle}>
              Controle de faturas e resumo financeiro por convenio
            </p>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={styles.tabsContainer}>
        <button
          style={activeTab === 'faturas' ? styles.tabActive : styles.tabInactive}
          onClick={() => setActiveTab('faturas')}
          onMouseEnter={(e) => { if (activeTab !== 'faturas') e.target.style.color = '#1976d2'; }}
          onMouseLeave={(e) => { if (activeTab !== 'faturas') e.target.style.color = '#666'; }}
        >
          Faturas
        </button>
        <button
          style={activeTab === 'resumo' ? styles.tabActive : styles.tabInactive}
          onClick={() => setActiveTab('resumo')}
          onMouseEnter={(e) => { if (activeTab !== 'resumo') e.target.style.color = '#1976d2'; }}
          onMouseLeave={(e) => { if (activeTab !== 'resumo') e.target.style.color = '#666'; }}
        >
          Resumo por Convenio
        </button>
      </div>

      {/* Conteudo da aba ativa */}
      {activeTab === 'faturas' ? renderFaturas() : renderResumo()}
    </div>
  );
}

export default Faturamento;
